<template>
    <div class="header">
        <div class="top">
            <div style="height: 70px">
                <div style="width: 350px" class="display-div">
                    <a href="/" class="logol"></a>
                </div>
                <div style="width: 402px;text-align: right;" class="display-div">
                    <div class="display-div">
                        <Dropdown>
                            <a href="javascript:void(0)">
                                <img class="wxgzh" :src="require('@/assets/gzh.jpg')" title="微信公众号">
                            </a>
                            <DropdownMenu slot="list">
                                <div class="wxgzh-max">
                                    <div>微信公众号</div>
                                    <img  :src="require('@/assets/gzh.jpg')" >
                                </div>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                </div>
                <div class="display-div" style="width: 240px;text-align: left;margin-left: 8px;height: 70px;">
                    <div style="line-height: 14px">
                        <span>协会电话：</span>
                        <span>{{page.phone}}</span>
                    </div>
                    <div>
                        <span>协会邮箱：</span>
                        <span>{{page.email}}</span>
                    </div>
                    <div style="line-height: 50px">
                        <Button  style="height: 25px;padding-top: 0px;margin-top: -25px;" type="success"  @click="toJoinThem('加入我们')"><h3 class="button-color">加入我们</h3></Button>
                    </div>

                </div>

            </div>
            <div class="clearfix"></div>
        </div>
        <div id="nav" class="nav">
            <ul>
                <li v-for="channel in channels" :key="channel.id">
                    <template v-if="channel.children">
                        <Dropdown class="nav-item">
                            <router-link :to="channel.children[0].to" :exact="channel.type==0">{{channel.name}}</router-link>
                            <DropdownMenu slot="list">
                                <DropdownItem v-for="item in channel.children" :key="item.id">
                                    <router-link v-if="item.to" :to="item.to">{{item.name}}</router-link>
                                    <a v-else :href="item.url" target="_blank" >{{item.name}}</a>
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </template>
                    <template v-else>
                        <router-link v-if="channel.to" :to="channel.to" :exact="channel.type==0">{{channel.name}}</router-link>
                        <a v-else :href="channel.url" target="_blank" >{{channel.name}}</a>
                    </template>
                </li>
            </ul>
        </div>
    </div>
</template>
<style lang="less">
    @import "../../common/mui";
    .display-div{
        display: inline-block;
    }
    .nav-item{
        & .ivu-select-dropdown{
            border-radius: 0px ;
            margin-top: 0px ;
            background: @color-main ;
        }
        & .ivu-dropdown-item{
            color: white ;
            padding: 0;
            text-align: center;
            height: 40px;
            line-height: 40px;
            &:hover{
                background-color: #f0c284;
            }
        }
    }
</style>
<style lang="less" scoped>
    @import "../../common/mui";
    .button-color{
        font-weight: 900 ;
        font-family: 微软雅黑;
    }
    .header{
        & .top{
            max-width: @page-max-width;
            margin: 0 auto;
            padding: 6px 0;
            & .logol{
                width: 350px;
                height: 60px;
                background: url(../../../assets/logo.png) no-repeat left;
                background-size:cover;
                /*margin-top: 17px;*/
                float: left;
            }
            & .contact{
                float: right;
                width: 300px;
                padding: 4px;
                font-size: 14px;
                & .contract-num{
                    font-size: 22px;
                    font-weight: bolder;
                    color: @color-main;
                }
            }
            .wxgzh{
                max-width: 65px;
            }
            .wxgzh-max{
                text-align: center;
                & img{
                    max-width: 200px;
                }
            }
        }
        & .nav{
            height: 40px;
            background-color: @color-main;
            color: white;

            & a{
                color: white;
                text-decoration: none;
                font-weight: bold;
                &:hover{
                    background-color: #f0c284;
                }
            }
            & > ul{
                max-width: @page-max-width;
                margin: 0 auto;
                display: flex;
                & > li{
                    height: 40px;
                    line-height: 40px;
                    list-style: none;
                    display: inline-block;
                    max-width: 160px;
                    flex: 1;
                    border-right: 1px solid #808695;

                    &:first-child{
                        border-left: 1px solid #808695;
                    }

                    & .nav-item{
                        display: block;
                        position: relative;
                        height: 100%;
                        width: 100%;

                    }

                    & a,& .nav-item .ivu-dropdown-rel a{
                        display: inline-block;
                        height: 100%;
                        width: 100%;
                        min-width: 100px;
                        font-size: 14px;
                        text-align: center;
                        line-height: 40px;

                        &.router-link-active,&.router-link-exact-active{
                            background-color: #f0c284;
                        }
                    }

                }
            }
        }

    }
</style>
<script>
    import {mapGetters} from 'vuex'
    export default {
        name:'v-header',
        data() {
            return {
            }
        },
        computed:{
            ...mapGetters('channel',{'channels':'tree'}),
            ...mapGetters('home',['page'])
        },
        components: {},
        methods:{
            /**
             * 加入我们（遍历所有目录，跳转到第一个‘加入我们’的链接）
             */
            toJoinThem(title){
                var id = 0;
                var flag = true;
                Object.values(this.channels).forEach((item)=>{
                    if(item.name === title && flag){
                        id = item.id;
                        flag = false;
                    }else {
                        if(item.children !== null && item.children !== undefined){
                            item.children.forEach((value)=>{
                                if(value.name === title && flag){
                                    id = value.id;
                                    flag = false;
                                }
                            });
                        }
                    }
                });
                this.$router.push('/channel/' + id);
            },
            formatUrl(item){
                if(item.url) return item.url;
                if(item.type==1){
                    return `/channel/${item.id}/${item.catalogId}`;
                }
                if(item.children){
                    let channel = item.children[0];
                    return '/channel/' + channel.id;
                }else{
                    let channel = item;
                    return '/channel/' + channel.id;
                }
            },
            toChannel(item){
                if(item.url){
                    this.$router.push(item.url);
                }else{
                    if(item.children){
                        let channel = item.children[0];
                        if(channel.url){
                            this.$router.push(channel.url)
                        }else{
                            this.$router.push('/channel/' + channel.id);
                        }
                    }else{
                        let channel = item;
                        this.$router.push('/channel/' + channel.id);
                    }
                }
            },
            toFirst(channel){
                if(channel.children){
                    let item = channel.children[0];
                    this.$router.push(item.url);
                }
            }
        }
    }
</script>
